import React, { useEffect, useId, useRef, useState } from 'react';
import { Col, Input, Row } from 'antd';
import "./style.scss";
import { onlyArabicNumberToEnglishString } from '../../utils/helper';
type onComplete = (input: any) => void
type justifyContent = "center" | "start" | "end" | "space-around" | "space-between" | "space-evenly" | undefined;

function OtpInput(
    { inputsNumber, justify = "center", onComplete, gutter = 0, toEnglishNumber = true }:
        { inputsNumber: number, onComplete: onComplete, justify: justifyContent, gutter: any, toEnglishNumber?: boolean }
) {
    const [otp, setOtp] = useState(Array(inputsNumber).fill(""));
    const otpRef: any = useRef<HTMLInputElement[]>(Array(inputsNumber).fill(null));
    const id = useId();
    function onChange({ value = "", index }: { value: any, index: number }) {
        if (!onlyArabicNumberToEnglishString(value).length) {
            return
        }
        const newOtp = [...otp];
        newOtp[index] = onlyArabicNumberToEnglishString(value);
        setOtp(newOtp);
        if (index && otpRef.current?.[0]) {
            otpRef.current?.[0].blur();
        }
        if (value.length === 1 && index < inputsNumber - 1) {
            otpRef.current[index + 1]?.focus();
        }

        if (newOtp.every((digit) => digit)) {
            onComplete(newOtp.join(''));
        } else {
            onComplete(undefined);
        }
    }
    function handleKeyDown(event: any, index: number) {
        if (event.key === "Backspace") {
            event.preventDefault();
            if (otp[index] !== "") {
                setOtp((prevOtp) => {
                    const newOtp = [...prevOtp];
                    newOtp[index] = "";
                    return newOtp;
                });
                onComplete(undefined);
            } else if (index > 0) {
                otpRef.current[index - 1]?.focus();
                setOtp((prevOtp) => {
                    const newOtp = [...prevOtp];
                    newOtp[index - 1] = "";
                    return newOtp;
                });
                onComplete(undefined);
            }
        }
    }
    function handlePaste(event: React.ClipboardEvent<HTMLInputElement>, index: number) {
        const paste = event.clipboardData.getData('text');
        if (!onlyArabicNumberToEnglishString(paste).length) {
            return
        }
        const newOtp = [...otp];
        const pasteArray = onlyArabicNumberToEnglishString(paste).split('').slice(0, inputsNumber - index); // Limit paste length to remaining inputs
        pasteArray.forEach((char, i) => {
            newOtp[index + i] = char;
        });
        setOtp(newOtp);
        if (newOtp.every((digit) => digit)) {
            onComplete(newOtp.join(''));
        } else {
            onComplete(undefined);
        }
        const nextFocusIndex = Math.min(index + pasteArray.length, inputsNumber - 1);
        otpRef.current[nextFocusIndex]?.focus();
        event.preventDefault();
    }
    useEffect(() => {
        otpRef.current[0].focus();
    }, []);
    return (
        <Row justify={justify} align={"middle"} gutter={gutter} style={{ direction: "ltr" }}>
            {
                Array.from({ length: inputsNumber }, (_, index) => (
                    <Col key={`otp-input-${index}-${inputsNumber}${id}`}>
                        <Input
                            maxLength={1}
                            className='OtpInput-input forceStyle'
                            value={otp?.[index]}
                            onChange={(event: any) => { onChange({ value: event.target?.value, index }) }}
                            ref={(ref) => { otpRef.current[index] = ref }}
                            size='large'
                            inputMode="numeric"
                            onKeyDownCapture={(event) => handleKeyDown(event, index)}
                            onFocus={(event) => event.target.select()}
                            onPaste={(event) => handlePaste(event, index)}
                            type="tel"
                            pattern="[0-9]*"
                        />
                    </Col>
                ))
            }
        </Row>
    )
}

export default OtpInput;